import React from 'react'
import type { SegmentIconKey } from '../../../../types/loyaltySegments'

// The 8 segment icons from the reference mockup's `segIcon(key)` map
// (breadstack-loyalty-pro.html) plus `users` — the one generic people glyph
// the audience-segments mockup draws on every default card — reproduced as
// inline Feather-style SVGs: stroke currentColor, strokeWidth 2, viewBox
// 0 0 24 24. Color comes from the parent's `color` style.

const ICON_PATHS: Record<SegmentIconKey, React.ReactNode> = {
  users: (
    <>
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
    </>
  ),
  star: (
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  ),
  warn: (
    <>
      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
    </>
  ),
  sparkle: (
    <polygon points="12 2 13.09 8.26 19 9.27 14 14.14 15.18 21.02 12 17.77 8.82 21.02 10 14.14 5 9.27 10.91 8.26 12 2" />
  ),
  crown: <path d="M2 18h20l-2-9-5 4-5-7-5 7-5-4z" />,
  cake: (
    <>
      <path d="M20 21V11a2 2 0 00-2-2H6a2 2 0 00-2 2v10" />
      <path d="M2 21h20M7 9V5.5a2.5 2.5 0 015 0V9" />
    </>
  ),
  trend: (
    <>
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </>
  ),
  shop: <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />,
  sleep: <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />,
}

interface SegmentIconProps {
  iconKey: string
  size?: number
}

// Unknown / legacy keys fall back to the star icon, mirroring the mockup's
// `icons[key] || icons.star`.
export const SegmentIcon: React.FC<SegmentIconProps> = ({
  iconKey,
  size = 18,
}) => (
  <svg
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    width={size}
    height={size}
  >
    {ICON_PATHS[iconKey as SegmentIconKey] ?? ICON_PATHS.star}
  </svg>
)
